/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
(function () {
  /**
   *  Вид для подфильтровых страниц
   */
  app.CategoryFilterPagesView = app.View.extend({
    events: {
      'click .filter-pages-more': 'toggleMoreFilterPages',
    },
    /**
     * Высота всех видимых подфильтровых страниц.
     * @type {number}
     */
    heightSubfilterPages: 70,
    /**
     * Выводить ссылку "Показать еще" на одной линии с подфильтровыми страницами
     * @type {boolean}
     */
    isMoreButtonInline: false,
    /**
     * Нужно ли обновлять пфс динамически
     */
    withDynamicData: false,
    additionalOptions: [
      'heightSubfilterPages',
      'isMoreButtonInline',
      'router',
      'filterPageKey',
      'isGroupFilterPages',
      'mainWindow',
    ],

    /** @inheritDoc */
    run: function () {
      this.listenTo(Backbone, 'update-filter-pages', this.updateFilterPageStatus);
      this.moreButton = this.$('.filter-pages-more');
      if (this.isGroupFilterPages) {
        this.childViews.tabsView = new app.TabsBaseItemView({
          el: this.$el,
        });
        this.listenTo(this.childViews.tabsView, 'tab:selected', this.hideOverflowed);
      }
      this.hideOverflowed();
      this.$el.removeClass('top');
      this.listenTo(this.mainWindow, 'window.resize', this.hideOverflowed);
      if (this.model) {
        this.listenTo(this.model, 'sync', this.render);
        if (this.isGroupFilterPages) {
          this.template = app.helpers.TemplateHelper.getTemplate('#grouped-filter-page-template');
          this.$filterPagesWrapper = this.$el;
          this.listenTo(Backbone, 'change-category-id', this.handleCategoryChange);
        } else {
          this.template = app.helpers.TemplateHelper.getTemplate('#filter-page-template');
          this.$filterPagesWrapper = this.$('.js-filter-pages-list');
        }
      }
    },

    /**
     * Обработка смены категории на странице ("Шины и Диски").
     * @param {string} slug - путь к подфильтровой странице
     * @param {Number} categoryId - идентификатор выбранной категории.
     */
    handleCategoryChange: function (slug, categoryId) {
      this.currentCategoryId = categoryId;
    },

    /** @inheritDoc */
    render: function () {
      var items = this.model.get(this.filterPageKey);
      var hasItems = this.isGroupFilterPages
        ? Object.keys(items).length > 0
        : items.length > 0;
      var templateData = {};
      if (hasItems) {
        this.toggle(false);
        if (this.isGroupFilterPages) {
          var filterTabGroups = this.model.get('groups');
          var activeTab = _.find(filterTabGroups, { active: true });
          var activeTabId = '';
          if (!activeTab) {
            activeTabId = _.map(filterTabGroups, 'id')[0];
          } else {
            activeTabId = activeTab.id;
          }
          templateData = {
            filterTabGroups: Object.keys(items).length === 1 ? null : filterTabGroups,
            filterPageGroups: items,
            currentCategoryId: this.currentCategoryId,
            entryScriptName: app.entryScriptName,
            activeTabId: activeTabId,
          };
        } else {
          templateData = {
            pages: items,
            each: _.each,
          };
        }
        this.$filterPagesWrapper.html(this.template(templateData));
        this.moreButton = this.$('.filter-pages-more');
        this.hideOverflowed();
      } else {
        this.toggle(true);
      }
    },

    /**
     * Скрывает блок подфильтровых
     * @param shouldHide блок подфильтровых должен скрыться.
     */
    toggle: function (shouldHide) {
      this.$el.parent().toggleClass('not_display', shouldHide);
    },

    /**
     * Обновляем статус подфильтровых страниц при каждом обновлении
     * выбранных фильтров.
     */
    updateFilterPageStatus: function (appliedFilterPages) {
      var pages = this.$('.filter-page'),
        pageId;
      _.each(pages, function (el) {
        pageId = $(el).find('span').data('id');
        var isAppliedFilterPage = _.some(appliedFilterPages, {id: pageId});
        $(el).find('.button').toggleClass('active-subfilter-page', isAppliedFilterPage);
      });
    },
    /**
     * Прячем ссылки, которые не влазят
     */
    hideOverflowed: function () {
      var selectedContentBlock = this.isGroupFilterPages ? this.childViews.tabsView.getSelectedTabContent() : null,
        filterPages = selectedContentBlock ? selectedContentBlock.find('.filter-page') : this.$('.filter-page'),
        hiddenPFS = [];
      _.each(filterPages.removeClass('not_display').get().reverse(), function (elem) {
        if (elem.offsetTop > this.heightSubfilterPages) {
          hiddenPFS.push(elem);
        } else {
          return false;
        }
      }.bind(this));
      $(hiddenPFS).addClass('not_display');
      if (hiddenPFS.length) {
        this.moreButton.removeClass('not_display');
        this.showMore = 'Показать ещё';
        if (this.isGroupFilterPages) {
          var countHiddenFilterPages = hiddenPFS.length;
          this.showMore = this.showMore + ' ' + countHiddenFilterPages;
        }
        this.moreButton.text(this.showMore);
        if (app.isMobile) {
          this.moreButton.removeClass('opened');
        }
        this.isMoreButtonInline && this.hideFPSForShowMoreButton(filterPages.not('.not_display'));
      } else {
        this.moreButton.addClass('not_display');
      }
    },

    /**
     * Скрывает пфс, чтобы кнопка показать ещё была видна.
     * @param {jQuery} filterPages Подфильтровые страницы.
     */
    hideFPSForShowMoreButton: function (filterPages) {
      _.each(filterPages.get().reverse(), function (elem) {
        if (this.moreButton[0].offsetTop > this.heightSubfilterPages) {
          $(elem).addClass('not_display');
        } else {
          return false;
        }
      }.bind(this));
    },

    /**
     * Метод для показа/скрытия подфильтровых страниц
     */
    toggleMoreFilterPages: function () {
      var wrapper = this.$('.filter-pages'),
        initialWrapperHeight = wrapper.outerHeight(),
        hiddenFilterPages = this.$('.filter-page.not_display');
      if (hiddenFilterPages.length) {
        var scrollTop = $(window).scrollTop();
        _.each(hiddenFilterPages, function (elem, index) {
          $(elem).removeClass('not_display');
          if (index === hiddenFilterPages.length - 1) {
            this.stopListening(this.mainWindow, 'window.resize', this.hideOverflowed);
            this.moreButton.text('Скрыть');
            if (app.isMobile) {
              this.moreButton.addClass('opened');
            }
            return;
          }
          if (wrapper.outerHeight() - initialWrapperHeight >= $(elem).outerHeight() * 2) {
            $(elem).addClass('not_display');
            return false;
          }
        }.bind(this));
        $(window).scrollTop(scrollTop);
      } else {
        this.listenTo(this.mainWindow, 'window.resize', this.hideOverflowed);
        this.moreButton.text(this.showMore);
        this.hideOverflowed();
      }
    },
  });
})();

}.call(window));